import React from 'react';
import { clsx } from 'clsx';

import type { ISmallLoader } from './interfaces/ISmallLoader';

import styles from './sass/SmallLoader.module.scss';

function SmallLoader({ className, size = 16 }: ISmallLoader) {
  return (
    <div
      className={clsx(styles.smallLoader, className)}
      style={{ width: size, height: size }}
    >
      <div className={styles.dotContainer}>
        <div className={styles.dot} />
        <div className={styles.dot} />
        <div className={styles.dot} />
        <div className={styles.dot} />
        <div className={styles.dot} />
        <div className={styles.dot} />
      </div>
    </div>
  );
}

export default SmallLoader;
